import { useState, useCallback } from "react"
import type { CombinedItem } from "../utils/item-helpers"
import { getSelectableItems } from "../utils/item-helpers"

export const useItemSelection = (allItems: CombinedItem[]) => {
  const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set())

  const toggleItem = useCallback((itemId: number) => {
    setSelectedItems((prev) => {
      const newSet = new Set(prev)
      if (newSet.has(itemId)) {
        newSet.delete(itemId)
      } else {
        newSet.add(itemId)
      }
      return newSet
    })
  }, [])

  const toggleAll = useCallback(() => {
    const selectableItems = getSelectableItems(allItems)

    if (selectedItems.size === selectableItems.length) {
      setSelectedItems(new Set())
    } else {
      setSelectedItems(new Set(selectableItems.map((item) => item.id)))
    }
  }, [allItems, selectedItems.size])

  const isAllSelected = () => {
    const selectableItems = getSelectableItems(allItems)
    return selectedItems.size === selectableItems.length && selectableItems.length > 0
  }

  const clearSelection = useCallback(() => {
    setSelectedItems(new Set())
  }, [])

  return {
    selectedItems,
    toggleItem,
    toggleAll,
    isAllSelected,
    clearSelection
  }
}
